import {Extendable, phone} from '@rocket-ui/tools';
import React, {ElementType} from 'react';

interface Props {
	value: string;
	format?: string;
}

export type FormattedPhoneProps<TTag extends ElementType> = Extendable<Props, TTag>;

export const FormattedPhone = <T extends ElementType = typeof React.Fragment>({
	as,
	value,
	format,
	...props
}: FormattedPhoneProps<T>) => {
	const Tag = as || React.Fragment;

	return <Tag {...props}>{phone.format(value, format)}</Tag>;
};
